import {
  FormControlLabel,
  Radio as MuiRadio,
  RadioProps,
  Typography,
} from "@mui/material";
import { palette } from "../../../styles/theme";
import { ReactNode } from "react";
import { PropsWithDataTest } from "../../../types";

interface Props extends PropsWithDataTest<RadioProps> {
  checked: boolean;
  label: string | ReactNode;
}

const Radio = ({ onChange, checked, label, "data-test": dataTest }: Props) => {
  return (
    <FormControlLabel
      control={
        <MuiRadio data-test={dataTest} onChange={onChange} checked={checked} />
      }
      sx={{
        "& .MuiFormControlLabel-label": {
          fontSize: "14px",
          fontStyle: "normal",
          fontWeight: "400",
          lineHeight: "normal",
          color: palette.grey.nearBlack,
        },
      }}
      label={
        typeof label === "string" ? (
          <Typography variant="textRegular" color={palette.grey.primary}>
            {label}
          </Typography>
        ) : (
          label
        )
      }
    />
  );
};

export default Radio;
